import { useState } from 'react';

export default function useRadioButtonFilters(_data) {
  const [filters, setFilters] = useState(_data);

  function handleChange(value) {
    setFilters(
      filters.map(c => {
        const checked = value === c.value;
        return {
          ...c,
          checked,
        };
      })
    );
  }
  return [filters, handleChange];
}
